import { useState } from 'react'
import './CreatePartnerModal.css'
import { Partner, PartnerService } from '@/services/PartnerService'

interface EditPartnerModalProps {
  partner: Partner
  onClose: () => void
  onSuccess: () => void
}

export default function EditPartnerModal({ partner, onClose, onSuccess }: EditPartnerModalProps) {
  const [partnerName, setPartnerName] = useState(partner.name)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError(null)

    if (!partnerName.trim()) {
      setError('Partner name is required')
      return
    }

    if (partnerName.trim() === partner.name) {
      setError('Partner name has not changed')
      return
    }

    setIsSubmitting(true)

    try {
      await PartnerService.update(partner.id, partnerName.trim())
      onSuccess()
      onClose()
    } catch (err) {
      console.error('Error updating partner:', err)
      setError(err instanceof Error ? err.message : 'Failed to update channel partner')
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <div className="modal-overlay">
      <div className="create-partner-modal-content">
        <div className="modal-header">
          <h2>Edit Channel Partner</h2>
          <p>Update the name for this channel partner</p>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>

        <form onSubmit={handleSubmit} className="create-partner-form">
          <div className="form-field-group">
            <label htmlFor="partnerName">Partner Name *</label>
            <input
              type="text"
              id="partnerName"
              value={partnerName}
              onChange={(e) => setPartnerName(e.target.value)}
              placeholder="Enter channel partner name"
              disabled={isSubmitting}
              required
              maxLength={200}
              autoFocus
            />
            <span className="field-help">
              Partner ID: {partner.id}
            </span>
          </div>

          {error && (
            <div className="error-message">
              <span className="error-icon">⚠️</span>
              {error}
            </div>
          )}

          <div className="form-actions">
            <button type="button" className="btn-cancel" onClick={onClose} disabled={isSubmitting}>
              Cancel
            </button>
            <button type="submit" className="btn-submit" disabled={isSubmitting}>
              {isSubmitting ? 'Updating...' : 'Update Partner'}
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}
